export default {"src":"/_next/static/image/src/components/BillingInformationForm/visa.e8eccd9b058b7bae7c235b0144950efe.svg","height":24,"width":34};